var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-flex",
        { attrs: { md12: "" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  staticClass: "col-md-12",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.isFormValid,
                    callback: function($$v) {
                      _vm.isFormValid = $$v
                    },
                    expression: "isFormValid"
                  }
                },
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "FormFieldsContainer",
                        { attrs: { titulo: "Alertas de Fallas General" } },
                        [
                          _vm._t("prependInformacionGeneral"),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm4: "", md4: "" } },
                            [
                              _c("v-switch", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "`required`"
                                  }
                                ],
                                attrs: {
                                  label: _vm.activeAlerts
                                    ? "Alertas Activadas"
                                    : "Alertas Desactivadas",
                                  id: "activar_alertas",
                                  color: "green",
                                  hint: _vm.hint,
                                  "persistent-hint": true
                                },
                                on: { change: _vm.cleanInput },
                                model: {
                                  value: _vm.activeAlerts,
                                  callback: function($$v) {
                                    _vm.activeAlerts = $$v
                                  },
                                  expression: "activeAlerts"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "emailValidate",
                                    expression: "`emailValidate`"
                                  }
                                ],
                                attrs: {
                                  label: "E-mail",
                                  "single-line": "",
                                  type: "email",
                                  "data-vv-name": "emailValidate",
                                  "error-messages": _vm.errors.collect(
                                    "emailValidate"
                                  )
                                },
                                model: {
                                  value: _vm.email,
                                  callback: function($$v) {
                                    _vm.email = $$v
                                  },
                                  expression: "email"
                                }
                              }),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-style": "italic",
                                    margin: "0 auto",
                                    "font-size": "12px"
                                  }
                                },
                                [
                                  _vm._v(
                                    "Puede ingresar varios correos separados por punto y coma\n                (;)"
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _c("v-flex", {
                            attrs: { xs12: "", sm6: "", md6: "" }
                          })
                        ],
                        2
                      ),
                      _c("br"),
                      _c(
                        "FormFieldsContainer",
                        {
                          attrs: {
                            titulo: "Alertas de Uso en Horario no Autorizado"
                          }
                        },
                        [
                          _vm._t("prependInformacionGeneral"),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm3: "", md3: "" } },
                            [
                              _c("v-switch", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "`required`"
                                  }
                                ],
                                attrs: {
                                  label: _vm.activeAlerts2
                                    ? "Alertas Activadas"
                                    : "Alertas Desactivadas",
                                  id: "activar_alertas2",
                                  color: "green",
                                  hint: _vm.hint2,
                                  "persistent-hint": true
                                },
                                on: { change: _vm.cleanInput2 },
                                model: {
                                  value: _vm.activeAlerts2,
                                  callback: function($$v) {
                                    _vm.activeAlerts2 = $$v
                                  },
                                  expression: "activeAlerts2"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "emailValidate2",
                                    expression: "`emailValidate2`"
                                  }
                                ],
                                attrs: {
                                  label: "E-mail",
                                  "single-line": "",
                                  type: "email",
                                  "data-vv-name": "emailValidate2",
                                  "error-messages": _vm.errors.collect(
                                    "emailValidate2"
                                  )
                                },
                                model: {
                                  value: _vm.email2,
                                  callback: function($$v) {
                                    _vm.email2 = $$v
                                  },
                                  expression: "email2"
                                }
                              }),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-style": "italic",
                                    margin: "0 auto",
                                    "font-size": "12px"
                                  }
                                },
                                [
                                  _vm._v(
                                    "Puede ingresar varios correos separados por punto y coma\n                (;)"
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm2: "", md2: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Tiempo Desde",
                                  "single-line": "",
                                  type: "number",
                                  "persistent-hint": true,
                                  hint:
                                    "El valor introducido define el rango mínimo de hora, para conocer el uso fuera de horario de los vehículos"
                                },
                                model: {
                                  value: _vm.t_desde,
                                  callback: function($$v) {
                                    _vm.t_desde = $$v
                                  },
                                  expression: "t_desde"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm2: "", md2: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Tiempo Hasta",
                                  "single-line": "",
                                  type: "number",
                                  "persistent-hint": true,
                                  hint:
                                    "El valor introducido define el rango máximo de hora, para conocer el uso fuera de horario de los vehículos"
                                },
                                model: {
                                  value: _vm.t_hasta,
                                  callback: function($$v) {
                                    _vm.t_hasta = $$v
                                  },
                                  expression: "t_hasta"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        2
                      ),
                      _c(
                        "v-flex",
                        {
                          attrs: {
                            xs12: "",
                            sm12: "",
                            md12: "",
                            wrap: "",
                            layout: ""
                          }
                        },
                        [
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                xs12: "",
                                sm6: "",
                                md6: "",
                                "wrapper-files": ""
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    width: "100%",
                                    display: "flex",
                                    "justify-content": "flex-end"
                                  }
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticStyle: { height: "47px" },
                                      attrs: { color: "#ffe800" },
                                      on: { click: _vm.handleClick }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Guardar\n                "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c("br")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }